import React from 'react';
import {
  RegisterOptions,
  useFormContext,
} from 'react-hook-form/dist/index.ie11';
import { CookbookSelectWrapper } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import { addAsterisk } from 'src/components/enterprise/features/Corporate/components/Form/utils/addAsterisk';
import { timeZoneOptions } from 'src/components/enterprise/features/Corporate/components/Form/TimeZoneControl/TimeZoneControl.util';

export interface TimeZoneSelectProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
}

export function TimeZoneControl({
  name,
  id,
  rules,
}: TimeZoneSelectProps): JSX.Element {
  const { control, errors } = useFormContext();

  return (
    <CookbookSelectWrapper
      label={addAsterisk('Time Zone', rules)}
      name={name}
      id={id}
      options={timeZoneOptions}
      error={errors[name]}
      control={control}
      blockWidth
      rules={rules}
    />
  );
}
